/* NALLI — PDP behaviors (WS7).
 *
 * Consolidates live's inline PDP scripts:
 *   1. Share popover toggle + copy-link (live sections/product-information.liquid item 5)
 *   2. Sticky-bar share toggle (live blocks/add-to-cart.liquid shareSticky())
 *   3. Size-guide inch/cm tab toggle (live blocks/_product-details.liquid showTable —
 *      kept as a global because the CMS size-guide page markup calls it via
 *      onclick="showTable('inch', this)")
 *   4. Fabric metre stepper (live sections/product-information.liquid item 7):
 *      products tagged Fabric show a `.fabric-step` span (1.5m start, 0.5m per
 *      click, capped at data-max) feeding the #fabriclength Length property.
 *
 * Loaded from blocks/nalli-buy-buttons.liquid (and safe to load anywhere —
 * every behavior is feature-detected). Fixes vs live in rebuild/bugfixes/ws7.md
 * (null guards; copy alert kept for UX parity).
 *
 * NOTE (INVENTORY §WS7 / assets--dialog.js.md): live's dialog-close full-page
 * reload on /products/ is DROPPED. If the stale-state bug it papered over
 * reappears on 4.1.3, reinstate here via a document-level DialogCloseEvent
 * listener — do NOT patch core dialog.js.
 */

/* 3. Size-guide tabs — global, invoked by CMS page markup. */
window.showTable = function showTable(type, el) {
  document.getElementById('inchTable')?.classList.toggle('hidden', type !== 'inch');
  document.getElementById('cmTable')?.classList.toggle('hidden', type !== 'cm');
  document.querySelectorAll('.tabBtn').forEach((btn) => btn.classList.remove('active'));
  el?.classList.add('active');
};

function initShare() {
  const shareTriggers = document.querySelectorAll('.s-share:not([data-nalli-share-sticky])');
  const shareWrap = document.querySelector('.share-wrap.desk') || document.querySelector('.share-wrap');
  const closeBtn = shareWrap?.querySelector('.ui-dialog-titlebar-close');

  shareTriggers.forEach((shareTrigger) => {
    const parentIconWrap = shareTrigger.closest('.icon-wrap-pro');

    if (shareWrap) {
      shareTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        shareWrap.classList.toggle('active');
        shareTrigger.classList.toggle('active');
        parentIconWrap?.classList.toggle('active');
      });
    }

    if (closeBtn && shareWrap) {
      closeBtn.addEventListener('click', () => {
        shareWrap.classList.remove('active');
        shareTrigger.classList.remove('active');
        parentIconWrap?.classList.remove('active');
      });
    }
  });

  // 2. Sticky-bar share trigger toggles the .atc-share popup.
  document.querySelectorAll('[data-nalli-share-sticky]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelector('.atc-share .share-wrap')?.classList.toggle('active');
    });
  });

  // Copy link (all instances; live only wired the first).
  document.querySelectorAll('.copy_link').forEach((copyBtn) => {
    copyBtn.addEventListener('click', () => {
      const link = copyBtn.getAttribute('data-link');
      if (!link) return;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(link)
          .then(() => alert('✅ Link copied!'))
          .catch((err) => console.error('Clipboard API failed', err));
      } else {
        const tempInput = document.createElement('input');
        tempInput.value = link;
        document.body.appendChild(tempInput);
        tempInput.select();
        try {
          document.execCommand('copy');
          alert('✅ Link copied!');
        } catch (err) {
          console.error('execCommand fallback failed', err);
        }
        document.body.removeChild(tempInput);
      }
    });
  });
}

/* 4. Fabric metre stepper. */
function initFabricStepper() {
  const lengthInput = document.querySelector('#fabriclength');

  document.querySelectorAll('.quantity-selector.fabric-mode').forEach((selector) => {
    const span = selector.querySelector('.fabric-step');
    const minusBtn = selector.querySelector('.quantity-minus');
    const plusBtn = selector.querySelector('.quantity-plus');
    if (!span || !minusBtn || !plusBtn) return;

    const step = 0.5;
    const max = parseFloat(span.dataset.max) || Infinity;

    function updateValue(newVal) {
      if (newVal <= max) {
        const val = newVal.toFixed(1);
        span.textContent = val;
        if (lengthInput) lengthInput.value = val;
      }
    }

    minusBtn.addEventListener('click', () => {
      const val = parseFloat(span.textContent) || 0;
      updateValue(val - step);
    });

    plusBtn.addEventListener('click', () => {
      const val = parseFloat(span.textContent) || 0;
      updateValue(val + step);
    });
  });
}

function init() {
  initShare();
  initFabricStepper();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
